<script>
  export default {
    props: {
      item: Object,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
    }
  }
</script>

<template>
    <div>
        <dl>
            <dt>Tipo de compra</dt>
            <dd>Locação de Veículos</dd>
        </dl>

        <dl v-if="item.projetoMetaEtapa !== null">
            <dt>Meta etapa</dt>
            <dd>{{ `${item.projetoMetaEtapa.meta.nome} - ${item.projetoMetaEtapa.etapa.nome}` }}</dd>
        </dl>

        <div class="row" v-if="configuracao.exibirRubricaSubrubricaSolicitacaoWeb">
            <dl class="col-xs-6">
                <dt>Rubrica</dt>
                <dd>{{ item.rubrica.nome }}</dd>
            </dl>

            <dl class="col-xs-6">
                <dt>Subrubrica</dt>
                <dd>{{ item.subrubrica.nome }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idTipoProduto > 0">
            <dl class="col-xs-12">
                <dt>Tipo de produto</dt>
                <dd>{{ item.tipoProduto ? item.tipoProduto.nomeTipoProduto : "---" }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idProduto > 0">
            <dl class="col-xs-12">
                <dt>Produto</dt>
                <dd>{{ item.produto ? item.produto.nome : "---" }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl :class="[configuracao.utilizarValorEstimado ? 'col-xs-6' : 'col-xs-12']">
                <dt>Quantidade</dt>
                <dd>{{ item.quantidade | fixar2digitos }}</dd>
            </dl>

            <dl class="col-xs-6" v-if="configuracao.utilizarValorEstimado">
                <dt>Valor estimado</dt>
                <dd>R$ {{ item.valorEstimado | fixar2digitos }}</dd>
            </dl>
        </div>

        <dl>
            <dt>Descrição do material/serviço</dt>
            <dd class="white-space-pre">{{ item.descricao }}</dd>
        </dl>

        <dl>
            <dt>Nome do motorista</dt>
            <dd>{{ item.nomeMotorista }}</dd>
        </dl>

        <div class="row">
            <dl class="col-xs-4">
                <dt>CNH</dt>
                <dd>{{ item.cnh }}</dd>
            </dl>
            <dl class="col-xs-4">
                <dt>Validade CNH</dt>
                <dd>{{ item.validadeCnh | formatarNumeroEmData }}</dd>
            </dl>
            <dl class="col-xs-4">
                <dt>Data de nascimento</dt>
                <dd>{{ item.dataNascimento | formatarNumeroEmData }}</dd>
            </dl>
        </div>

        <div class="row" v-if="configuracao.mostrarPeriodoSolicitacaoCompraItemLocacao">
            <dl class="col-xs-6">
                <dt>Período início</dt>
                <dd>{{ item.dataCheckin | formatarNumeroEmData }}</dd>
            </dl>
            <dl class="col-xs-6">
                <dt>Período fim</dt>
                <dd>{{ item.dataCheckout | formatarNumeroEmData }}</dd>
            </dl>
        </div>

        <dl v-if="!configuracao.solCompraOcultarObservacoes">
            <dt>Observação do item de compra</dt>
            <dd class="white-space-pre">{{ item.observacaoItemCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Objetivo/Justificativa da compra</dt>
            <dd class="white-space-pre">{{ item.objetivoCompra || '---' }}</dd>
        </dl>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormListaLocacaoDeVeiculos.vue